import { Row, Col, Form, Input, FormInstance, Typography } from 'antd';
/**
 * @component CloseNoteTaskForm.tsx
 * @description CloseNoteTaskForm component to create a note close to a task.
 * @return { Component }
 */
interface NotaDeCierreTareaFormProps {
  form: FormInstance;
}
function CloseNoteTaskForm(props: NotaDeCierreTareaFormProps) {

  const { Text } = Typography;

  return (
    <div className="org-task-form">
      <Row>
        <Col span={24}>
          <Form layout={'vertical'} form={props.form} name="TaskTypeForm">
          <Form.Item name={'notaDeCierre'} label={<Text strong>¿Deseas dejar alguna Nota de Cierre?</Text>}>
            <Input.TextArea
              required
              placeholder={'Ingresa aquí tu Nota de Cierre ...'}
              value={''}
              rows={7}
              className='tp-task-map__form__content_inputarea textarea-large'
            />
          </Form.Item>
          </Form>
          <Text>
            Una vez que cierres la Tarea, no podrás deshacer la acción.
          </Text>
        </Col>
      </Row>
    </div>
  );
}

export default CloseNoteTaskForm;
